
<template>
    <template v-if="item?.data">
        <div class="tag source" :class="{ [source(item)]: true }">{{ source(item) }}</div>
        <div class="tag workflowcard useHand"
             v-for="workflowcard_id in related(item, 'WorkflowcardEntity')"
             :key="workflowcard_id"
             @click.prevent="handleRelatedClick(item, 'WorkflowcardEntity', workflowcard_id)"
        >
            <Icon name="link" />
            <span class="title" :title="`ID: ${workflowcard_id}`">
                <cardtitle v-if="entity('workflowcard', workflowcard_id)" :data="entity('workflowcard', workflowcard_id)" :key="workflowcard_id" />
            </span>
        </div>
    </template>
</template>

<script>
import {defineComponent, onMounted, computed, inject, ref, watch, onUnmounted} from "vue";
import { useRouter } from "vue-router";

// Config for API urls used in this vue template
import trans from "helpers/_translation";
import { routeData } from "helpers/_inbox-helpers";

import { unlinkInbox } from "store/inbox-store";
import { item as entity } from "store/portal";

import Icon from "components/icon";

import cardtitle from "components/workflowcard/cardtitle";
import PopupConfirm from "components/popupConfirm";

export default defineComponent({
    name: "inbox-tags",
    components: {
        Icon,
        cardtitle,
        PopupConfirm
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const router = useRouter();

        const popupConfirmRef = ref();
        const addNotification = inject("addNotification");

        const item = computed(() => {
            return props.item;
        });
        const source = (item) => {
            return computed(() => {
                return item?.data?.source ?? "email";
            }).value;
        };

        const related = (item, module_object) => {
            return computed(() => {
                if (item.data.module_object
                    && (item.data.module_object === module_object.replace("Entity", ""))
                ) {
                    // In case of emailsent we check for specific id set.
                    return [item.data.item_id];
                }
                return item?.extra?.related_ids?.[module_object] ?? [];
            }).value;
        };
        const handleRelatedClick = (item, module_object, related_id = "") => {
            const moduleMap = {
                "WorkflowcardEntity": "workflowcard"
            };
            router.push(`/${moduleMap[module_object]}/${related_id}`);
        };

        return {
            trans,
            item,
            entity,
            source,
            related,

            handleRelatedClick,

            routeData,

            popupConfirmRef
        }
    }
});

</script>
